const InactiveHeaderImage = () => (
  <svg
    width="142"
    height="143"
    viewBox="0 0 142 143"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="inactive-header-image"
  >
    <g clipPath="url(#clip0_776_11030)">
      <circle cx="71" cy="71.0625" r="71" fill="#EBF3FF" />
      <path
        d="M121.196 10.1509C121.948 9.14019 123.566 9.6571 123.395 10.8531L122.374 17.9738C122.313 18.3964 122.5 18.8012 122.861 19.029L128.945 22.8681C129.967 23.5129 129.311 25.0802 128.054 24.9972L120.571 24.5033C120.127 24.474 119.686 24.678 119.42 25.0351L114.945 31.0526C114.194 32.0632 112.575 31.5463 112.747 30.3504L113.768 23.2297C113.828 22.8071 113.641 22.4023 113.28 22.1744L107.197 18.3353C106.175 17.6906 106.831 16.1232 108.087 16.2062L115.57 16.7002C116.014 16.7295 116.456 16.5255 116.721 16.1684L121.196 10.1509Z"
        fill="#F1953F"
      />
      <path
        d="M7.51347 127.5C7.78003 126.737 8.86986 126.744 8.99397 127.509L9.73293 132.064C9.77679 132.334 9.96881 132.546 10.2335 132.616L14.6934 133.802C15.4424 134.001 15.3412 135.086 14.5559 135.276L9.88011 136.407C9.60262 136.474 9.37129 136.683 9.27711 136.953L7.69003 141.494C7.42348 142.257 6.33365 142.25 6.20953 141.485L5.47057 136.93C5.42671 136.66 5.23469 136.448 4.97002 136.377L0.510139 135.192C-0.238916 134.993 -0.13774 133.908 0.647584 133.718L5.3234 132.587C5.60089 132.52 5.83221 132.311 5.9264 132.041L7.51347 127.5Z"
        fill="#F1953F"
      />
      <rect x="26" y="40.677" width="90" height="101.385" rx="6" fill="white" />
      <path
        d="M35.8455 32.7173C35.8455 29.4036 38.5318 26.7173 41.8455 26.7173H100.155C103.468 26.7173 106.155 29.4036 106.155 32.7173V35.7139H35.8455V32.7173Z"
        fill="white"
      />
      <path
        d="M71 102.562C84.2548 102.562 95 91.8173 95 78.5625C95 65.3077 84.2548 54.5625 71 54.5625C57.7452 54.5625 47 65.3077 47 78.5625C47 91.8173 57.7452 102.562 71 102.562Z"
        fill="#99C5FF"
      />
      <path
        d="M69.5852 88.4661L69.5852 79.9774L61.0966 79.9774L61.0966 77.1479L69.5852 77.1479L69.5852 68.6593L72.4148 68.6593L72.4148 77.1479L80.9034 77.1479L80.9034 79.9774L72.4148 79.9774L72.4148 88.4661L69.5852 88.4661Z"
        fill="white"
      />
      <path
        d="M84 108.562H58C56.3431 108.562 55 109.906 55 111.562C55 113.219 56.3431 114.562 58 114.562H84C85.6569 114.562 87 113.219 87 111.562C87 109.906 85.6569 108.562 84 108.562Z"
        fill="#DFEAFB"
      />
      <path
        d="M93 120.562H49C47.3431 120.562 46 121.906 46 123.562C46 125.219 47.3431 126.562 49 126.562H93C94.6569 126.562 96 125.219 96 123.562C96 121.906 94.6569 120.562 93 120.562Z"
        fill="#DFEAFB"
      />
    </g>
    <defs>
      <clipPath id="clip0_776_11030">
        <rect
          width="142"
          height="142"
          fill="white"
          transform="translate(0 0.0625)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default InactiveHeaderImage;
